<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Word-Separator-Root',
};
</script>
